// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Your phone number`
};

const de_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Deine Telefonnummer`
};

const es_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Tu número de teléfono`
};

const fr_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Votre numéro de téléphone`
};

const fi_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Puhelinnumerosi`
};

const hi_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `आपका फोन नंबर`
};

const ja_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `あなたの電話番号`
};

const nl_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Je telefoonnummer`
};

const pt_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Seu número de telefone`
};

const ro_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Numărul tău de telefon`
};

const th_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `หมายเลขโทรศัพท์ของคุณ`
};

const ur_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `آپ کا فون نمبر`
};

const zh_hant1_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `您的電話號碼`
};

const da_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Dit telefonnummer`
};

const it_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Il tuo numero di telefono`
};

const vn_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Số điện thoại của bạn`
};

const ko_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `귀하의 전화번호`
};

const tr_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Telefon numaranız`
};

const lv_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Jūsu tālruņa numurs`
};

const ar_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `رقم هاتفك`
};

const bs_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Vaš broj telefona`
};

const sl_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Vaša telefonska številka`
};

const id_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Nomor telepon Anda`
};

const sv_widget_login_phone_number_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Ditt telefonnummer`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_login_phone_number_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_login_phone_number_placeholder(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_login_phone_number_placeholder", locale)
	if (locale === "en") return en_widget_login_phone_number_placeholder(inputs)
	if (locale === "de") return de_widget_login_phone_number_placeholder(inputs)
	if (locale === "es") return es_widget_login_phone_number_placeholder(inputs)
	if (locale === "fr") return fr_widget_login_phone_number_placeholder(inputs)
	if (locale === "fi") return fi_widget_login_phone_number_placeholder(inputs)
	if (locale === "hi") return hi_widget_login_phone_number_placeholder(inputs)
	if (locale === "ja") return ja_widget_login_phone_number_placeholder(inputs)
	if (locale === "nl") return nl_widget_login_phone_number_placeholder(inputs)
	if (locale === "pt") return pt_widget_login_phone_number_placeholder(inputs)
	if (locale === "ro") return ro_widget_login_phone_number_placeholder(inputs)
	if (locale === "th") return th_widget_login_phone_number_placeholder(inputs)
	if (locale === "ur") return ur_widget_login_phone_number_placeholder(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_login_phone_number_placeholder(inputs)
	if (locale === "da") return da_widget_login_phone_number_placeholder(inputs)
	if (locale === "it") return it_widget_login_phone_number_placeholder(inputs)
	if (locale === "vn") return vn_widget_login_phone_number_placeholder(inputs)
	if (locale === "ko") return ko_widget_login_phone_number_placeholder(inputs)
	if (locale === "tr") return tr_widget_login_phone_number_placeholder(inputs)
	if (locale === "lv") return lv_widget_login_phone_number_placeholder(inputs)
	if (locale === "ar") return ar_widget_login_phone_number_placeholder(inputs)
	if (locale === "bs") return bs_widget_login_phone_number_placeholder(inputs)
	if (locale === "sl") return sl_widget_login_phone_number_placeholder(inputs)
	if (locale === "id") return id_widget_login_phone_number_placeholder(inputs)
	if (locale === "sv") return sv_widget_login_phone_number_placeholder(inputs)
	return "widget_login_phone_number_placeholder"
};